<script lang="ts">import NotificationsModal from "./modals/notifications-modal.svelte";
import { stateUi } from "@infinitro/config";
import { isMobile } from "@infinitro/global";
import { onMount } from "svelte";
import NotificationsList from "./parts/notifications-list.svelte";
let animateOpacity = $state(false);
let notificationsElement = $state(null);
let isNotificationsOpen = $state(false);
onMount(() => {
	const handleClickOutside = (event) => {
		if (isNotificationsOpen && $isMobile && notificationsElement) {
			const notificationsRect = notificationsElement.getBoundingClientRect();
			const clickX = event.clientX;
			const clickY = event.clientY;
			const clickedOutsidenotifications = clickX > notificationsRect.right || clickX < notificationsRect.left;
			const clickedAtSidesOnly = clickY > notificationsRect.top && clickY < notificationsRect.bottom;
			if (clickedOutsidenotifications && clickedAtSidesOnly) {
				isNotificationsOpen = false;
			}
		}
	};
	document.addEventListener("click", handleClickOutside);
	// Function to set the viewport height CSS variable
	const setViewportHeight = () => {
		const vh = window.innerHeight * .01;
		document.documentElement.style.setProperty("--vh", `${vh}px`);
	};
	// Set it initially
	setViewportHeight();
	// Update on resize
	window.addEventListener("resize", setViewportHeight);
	// Update on orientation change specifically for iOS
	window.addEventListener("orientationchange", setViewportHeight);
	return () => {
		document.removeEventListener("click", handleClickOutside);
		window.removeEventListener("resize", setViewportHeight);
		window.removeEventListener("orientationchange", setViewportHeight);
	};
});
let useAlternative2 = $derived($stateUi.notifications.notificationsStyle === "alternative2");
let useAlternative4 = $derived($stateUi.notifications.notificationsStyle === "alternative4");
</script>

{#if $isMobile}
	<NotificationsModal />
{:else}
	<aside
		id="notifications"
		class="open {animateOpacity ? 'animated' : ''} {$isMobile ? 'mobile' : ''} no-top-border"
		class:alternative2-notifications={useAlternative2}
		class:alternative4-notifications={useAlternative4}
		aria-label="notifications"
		bind:this={notificationsElement}
	>
		<NotificationsList />
	</aside>
{/if}

<style>
	@keyframes fadeOpacity {
		0%,
		100% {
			opacity: 1;
			filter: blur(1px);
		}
		10%,
		90% {
			opacity: 0.7;
			filter: blur(2px);
		}
		50% {
			opacity: 0.5;
			filter: blur(3px);
		}
	}

	aside {
		position: fixed;
		right: 0px;
		flex-shrink: 0;
		flex-direction: column;
		justify-content: space-between;
		overflow-y: auto;
		border-width: 1px;
		border-right-width: 0px;
		border-bottom-width: 0px;
		border-color: var(--color-neutral-900);
		background-color: var(--color-background-700);
		--tw-bg-opacity: 1;
		padding-left: 0.5rem;
		padding-right: 0.5rem;
		padding-top: 0.5rem;
		padding-bottom: 0.5rem;
		--tw-backdrop-blur: blur(50px);
		backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
		transition-duration: 75ms;
		transition:
			width 0.2s ease,
			padding 0.2s ease;
		height: calc(var(--vh, 1vh) * 100 - 72px);
		max-height: calc(var(--vh, 1vh) * 100 - 72px);
		animation: none;
		@media (max-width: 1023px) {
			height: calc(var(--vh, 1vh) * 100 - 119px);
			max-height: calc(var(--vh, 1vh) * 100 - 119px);
		}
}

	@media (min-width: 1024px) {
		aside {
				visibility: visible;
				display: flex;
		}
	}
	aside::-webkit-scrollbar {
		width: 0px;
		background-color: transparent;
}

	aside::-webkit-scrollbar-thumb {
		border-radius: 0.75rem;
		background-color: var(--color-neutral-900);
		border: 2px solid transparent;
		background-clip: content-box;
}

	aside::-webkit-scrollbar-thumb:hover {
		background-color: var(--color-neutral-900);
}

	aside::-webkit-scrollbar-track {
		background-color: transparent;
}

	aside.open {
		width: 100vw;
}

	@media (min-width: 768px) {
		aside.open {
				width: 50vw;
		}
	}
	@media (min-width: 1024px) {
		aside.open {
				width: 240px;
		}
		aside.collapsed {
				width: 74px;
		}
	}
	aside.animated {
		animation: fadeOpacity 0.2s ease-in-out;
	}
	aside.no-top-border {
		border-top-width: 0px;
}

	aside:hover {
		overflow: auto;
		-webkit-overflow-scrolling: touch;
	}

	@media (max-width: 1024px) {
		.mobile {
				display: flex;
			transition:
				opacity 0.2s ease,
				transform 0.2s ease,
				position 0.2s ease;
			opacity: 1;
			transform: translateX(0);
		}
	}

	@media (min-width: 1024px) {
		.mobile {
				display: flex;
			opacity: 1;
			transform: none;
		}
	}

	.alternative2-notifications {
		border-style: none;
		background-color: transparent;
		--tw-backdrop-blur: blur(30px);
		backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
		background: linear-gradient(
			to bottom,
			rgba(var(--color-tertiary-100-rgb) / 0.4),
			rgba(var(--color-background-900-rgb) / 0.4)
		);
}
	.alternative4-notifications {
		border-width: 0px;
		background-color: var(--component-layout-side-bar-bg);
}
</style>
